import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import './Loader.module.scss';

/**
 * Import Font Awesome icons
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Loader extends Component {
    render() {
        return (
            <CSSTransition
                in
                appear
                timeout={0}
                classNames="fade"
                unmountOnExit
            >
                <div styleName="loader">
                    <FontAwesomeIcon icon={['fal', 'circle-notch']} spin />
                </div>
            </CSSTransition>
        );
    }
}

export default Loader;
